<template>
    <div class="pin-container">
        <div class="pin-frame">
            <EnterPinForm :cid="cid" @succeeded="onSucceeded"/>
            <div class="pin-hr" />
            <div class="pin-note">
                {{ $t('e2ee.note_tip') }}
                <a
                    :href="config.support_video_how_to_protection_url"
                    target="_blank"
                    class="ui-link cloud-support"
                >
                    <span class="text">{{ $t('e2ee.learn_more') }}</span>
                    <span class="ui-icon icon-icon_arrow-right" />
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import EnterPinForm from './EnterPinForm.vue';

export default Vue.extend({

    components: {
        EnterPinForm,
    },
    props: {
        /**
         * cmk id
         */
        cid: {
            type: String,
            required: true
        }
    },
    // emits: ['succeeded'],
    data () {

        return {
            config
        };

    },
    methods: {
        onSucceeded (): void {

            this.$emit( 'succeeded' );

        }
    }
});
</script>
<style lang="less" scoped>

.pin-tips {
    font-size: 16px;
    line-height: 19px;
    font-weight: 400;
}

.pin-container {
    font-family: @font_02;
    font-weight: 500;;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}

.pin-frame {
    font-family: @font_02;
    font-weight: 500;;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex-direction: column;
    max-width: 8rem;
    text-align: center;
    overflow: hidden;

    @media @mobile {
        margin: 0 0.4rem;
    }
}

.pin-hr {
    margin: 0.4rem 0;
    background-color: #a5a5a5;
    width: 100%;
    height: 1px;
}

.pin-note {
    font-family: @font_02;
    font-weight: 400;
    font-size: 16px;
    color: #555555;

    .ui-link {
        display: inline-block;

        .ui-icon,
        .text {
            font-size: 14px;
        }

        .ui-icon {
            margin-left: unset;
        }

        &:hover .ui-icon {
            right: -7px;
        }
    }
}
</style>
